import { JobInfo } from "./customer-job-info";
import { AddressFromSap } from "./response/address-from-SAP"
import { CustomerInfoFromSAPPerson } from "./response/customer-info-from-sap-person";

export class CustomerInfoFromSAP {
    personaNatural: CustomerInfoFromSAPPerson;
    personaJuridica: any; //TODO
    identificacion: any; //TODO
    direccionBP: Array<AddressFromSap>;
    datosLaborales: Array<JobInfo>;
    constructor() {
        this.personaNatural = new CustomerInfoFromSAPPerson();
        this.direccionBP = [];
        this.datosLaborales = [];
    }
}